import React from 'react';
import { useSelector } from 'react-redux';
import UserDateTimezoneFormat from '../../user-date-timezone-format';
import Global from '../../../store/global-selectors';
import { messages } from './messages';

const CellRender = (data, { isExpanded = false, isFirstRow = true } = {}) => {
  const { rate } =
    useSelector((state) =>
      Global.selectEntitiesFulfillmentPlanProperty(state, {
        fulfillmentPlanId: data?.id,
        property: 'rateSummary',
      }),
    ) ?? {};

  if ((isExpanded && !isFirstRow) || !rate?.estimatedPickup) {
    return null;
  }

  return <UserDateTimezoneFormat dateTime={rate?.estimatedPickup} showTime spaceBetweenTimeAndZone />;
};

export const PickupTime = {
  getMessageDescriptor: () => messages.pickupTime,
  id: 'pickup-time',
  render: CellRender,
};
